import Chart from 'chart.js/auto';

import { useEffect, useRef } from 'react';

export const CHART_TYPES = {
	bar: 'bar',
	line: 'line',
	pie: 'pie',
	doughnut: 'doughnut',
	radar: 'radar',
	polarArea: 'polarArea',
	bubble: 'bubble',
	scatter: 'scatter'
};

const BaseChart = ({ type, data = {}, options = {}, plugins }) => {
	const canvasRef = useRef(null);
	const chartRef = useRef(null);

	useEffect(() => {
		chartRef.current = new Chart(canvasRef.current, {
			type,
			data,
			options,
			plugins
		});

		return () => {
			chartRef.current.destroy();
		};
	}, [type, data, plugins, options]);

	return <canvas ref={canvasRef} role="img" />;
};

export default BaseChart;
